import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    options: { type: Object, default: {} },
    placeholder: String,
    notAllowRemove: Array
  }

  connect() {
    const self = this

    const defaultOptions = {
      valueField: 'value',
      labelField: 'text',
      searchField: 'text',
      create: false,
      maxOptions: null,
      maxItems: this.selectTarget.multiple ? null : 1,
      placeholder: this.placeholderValue,
      render: {
        option: function(data, escape) {
          return `<div class="flex items-center">
                    <span>${escape(data.text)}</span>
                  </div>`;
        },
        item: function(data, escape) {
          return `<div class="flex items-center gap-2">
                    <span>${escape(data.text)}</span>
                  </div>`;
        },
        option_create: function(data, escape) {
          return '<div class="create">新增 <strong>' + escape(data.input) + '</strong>&hellip;</div>';
        },
        no_results: function() {
          return '<div class="no-results">未找到結果</div>';
        },
      },
      onDelete(values, _event) {
        const hasNotAllowValue = values.find(v => self.notAllowRemoveValue.includes(v))

        return !hasNotAllowValue
      }
    }

    const options = {...defaultOptions, ...this.optionsValue}
    this.tomSelect = new TomSelect(this.selectTarget, options)

    if (this.notAllowRemoveValue.length > 0) { this.notAllowRemove() }
  }

  notAllowRemove() {
    const options = []
    this.notAllowRemoveValue.forEach(val => {
      options.push(document.querySelector(`[data-value='${val}']`))
    });
    options.forEach(option => {
      const removeLink = option.querySelector('.remove')
      removeLink.style.pointerEvents = 'none'
      removeLink.style.opacity = '0'
      removeLink.style.cursor = 'not-allowed'
    })
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
